module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/blue-back-arrow.svg";